import { render, staticRenderFns } from "./ProjectCrmActivities.vue?vue&type=template&id=6f446d13&"
import script from "./ProjectCrmActivities.vue?vue&type=script&lang=js&"
export * from "./ProjectCrmActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports